import React from 'react'
import Car from './carSection'
import Summary from './summarySection'
import Running from './runningSection'
import FinancialInclusion from './financialInclusionSection'
import EndOfLease from './endOfLeaseSection'
import Banner from './bannerSection'
import ReleaseSection from './releaseSection'

const IndividualEstimate = ({ children }) => <>{children}</>

IndividualEstimate.Release = ReleaseSection
IndividualEstimate.Car = Car
IndividualEstimate.Summary = Summary
IndividualEstimate.Running = Running
IndividualEstimate.FinancialInclusion = FinancialInclusion
IndividualEstimate.EndOfLease = EndOfLease
IndividualEstimate.Banner = Banner

export default IndividualEstimate
